import { Suspense, lazy, useMemo } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import LinearProgress from '@mui/material/LinearProgress';
import { ThemeProvider } from '@mui/material/styles';
import { createSmartHomeTheme } from '@smart-home/design-tokens';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminShell } from './components/AdminShell';
import { ProtectedRoute } from './components/ProtectedRoute';

const LoginPage = lazy(() => import('./pages/LoginPage').then((m) => ({ default: m.LoginPage })));
const DashboardPage = lazy(() => import('./pages/DashboardPage').then((m) => ({ default: m.DashboardPage })));
const UsersPage = lazy(() => import('./pages/UsersPage').then((m) => ({ default: m.UsersPage })));
const HomesPage = lazy(() => import('./pages/HomesPage').then((m) => ({ default: m.HomesPage })));
const DeviceCatalogPage = lazy(() => import('./pages/DeviceCatalogPage').then((m) => ({ default: m.DeviceCatalogPage })));
const DeviceRegistryPage = lazy(() => import('./pages/DeviceRegistryPage').then((m) => ({ default: m.DeviceRegistryPage })));
const HAMonitorPage = lazy(() => import('./pages/HAMonitorPage').then((m) => ({ default: m.HAMonitorPage })));
const ActivityLogsPage = lazy(() => import('./pages/ActivityLogsPage').then((m) => ({ default: m.ActivityLogsPage })));
const ScenesPage = lazy(() => import('./pages/ScenesPage').then((m) => ({ default: m.ScenesPage })));
const MemoryViewerPage = lazy(() => import('./pages/MemoryViewerPage').then((m) => ({ default: m.MemoryViewerPage })));
const SettingsPage = lazy(() => import('./pages/SettingsPage').then((m) => ({ default: m.SettingsPage })));

function PageLoader() {
  return <LinearProgress sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999 }} />;
}

export default function App() {
  const theme = useMemo(() => createSmartHomeTheme('dark'), []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AdminShell>
                  <Suspense fallback={<PageLoader />}>
                    <Routes>
                      <Route path="/" element={<DashboardPage />} />
                      <Route path="/users" element={<UsersPage />} />
                      <Route path="/homes" element={<HomesPage />} />
                      <Route path="/device-catalog" element={<DeviceCatalogPage />} />
                      <Route path="/device-registry" element={<DeviceRegistryPage />} />
                      <Route path="/ha-monitor" element={<HAMonitorPage />} />
                      <Route path="/activity-logs" element={<ActivityLogsPage />} />
                      <Route path="/scenes" element={<ScenesPage />} />
                      <Route path="/memory" element={<MemoryViewerPage />} />
                      <Route path="/settings" element={<SettingsPage />} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </Suspense>
                </AdminShell>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
}
